<template>
  <v-container class="text-center d-flex flex-column justify-center h-full">
    <v-card
      class="mx-auto pa-4"
      width="480"
      color="darknavyblue"
      elevation="5"
    >
      <v-card-title>Login</v-card-title>
      <v-card-text>
        <v-form>
          <v-text-field
            v-model="email"
            label="Email"
            type="email"
            aria-label="email"
            required
            prepend-icon="mdi-email"
          />
          <v-text-field
            v-model="password"
            label="Password"
            type="password"
            aria-label="password"
            required
            prepend-icon="mdi-lock"
          />
          <v-text-field
            v-model="token"
            label="2FA Code"
            aria-label="two-factor-code"
            required
            prepend-icon="mdi-key"
            @keydown.enter="handleLogin"
          />
          <v-btn
            color="primary"
            class="mt-4"
            block
            :disabled="loginDisabled"
            :loading="loading"
            @click="handleLogin"
          >
            Login
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script lang="ts">
import { LoginRequest, MFAMethod } from '@policyfly/protobuf/pfbingo'
import { computed, defineComponent, ref } from 'vue'
import { useRouter } from 'vue-router'

import { useApiStore } from '@/stores/api'

import { RouteNames } from '@/router'

export default defineComponent({
  name: 'Login',

  setup () {
    const email = ref('')
    const password = ref('')
    const token = ref('')
    const loginDisabled = computed(() => {
      return !email.value || !password.value || !token.value || loading.value
    })

    const apiStore = useApiStore()
    const loading = ref(false)
    const router = useRouter()
    async function handleLogin (): Promise<void> {
      if (loading.value || loginDisabled.value) return
      loading.value = true
      try {
        await apiStore.login(LoginRequest.create({
          email: email.value,
          password: password.value,
          otp: token.value,
          mfaMethod: MFAMethod.MFA_METHOD_TOTP,
          environmentId: import.meta.env.VITE_ENVIRONMENT_ID,
        }))
        await router.push({ name: RouteNames.DASHBOARD })
      } catch (error) {
        console.error('Login failed:', error)
      } finally {
        loading.value = false
      }
    }

    return {
      email,
      password,
      token,
      loginDisabled,
      loading,
      handleLogin,
    }
  },
})
</script>
